export const joinStringsWithDelimiter = (
  strings: (string | undefined | null)[],
  delimiter = ' '
) => strings.filter((string) => string && string.length > 0).join(delimiter)

export const upperCaseFirst = (input?: string): string | undefined =>
  input ? input[0].toLocaleUpperCase() + input.slice(1) : input

export const validateString = (input?: string | null | undefined) => input || '–'
